// A conifer: a short trunk under three stacked six-sided cones that taper to a
// point. Ported 1:1 from age-of-mcp's classic tree-pine.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.06, 0.09, 0.3, 5),
      color: "#4a3322", position: [0, 0.15, 0] },
    { geometry: new THREE.ConeGeometry(0.52, 0.72, 6),
      color: "#2f6a28", position: [0, 0.62, 0] },
    { geometry: new THREE.ConeGeometry(0.4, 0.66, 6),
      color: "#367a30", position: [0, 1.04, 0] },
    { geometry: new THREE.ConeGeometry(0.26, 0.6, 6),
      color: "#3f8c38", position: [0, 1.46, 0] },
  ];
}

export const treePine = defineModel({
  id: "tree-pine",
  batchId: "standard",
  name: "Tree pine",
  tags: ["scenery","tree","pine","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree pine.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => partsFor(),
  animations: [],
});
